module.exports = __webpack_public_path__ + "static/media/23.d3b97766.jpg";